import { graphql } from "gatsby";
import React from "react";
import LandingFundHighEstate from "../../../../components/Landing/LandingFund/LandingFundHighEstate";
import SEO from "../../../../components/HeadWrapper";

export default function Fund({ data }: { data: any }) {
  return (
    <LandingFundHighEstate
      sanityHome={data?.sanityHome}
      allFile={data?.allFile}
      data={data?.sanityFundraiserRealEstate}
      withLinkedinTrack={true}
      type="GoogleAds"
    />
  );
}

export const query = graphql`
  query FundraiserRealEstateQuery {
    allFile(filter: { relativePath: { regex: "/fund/" } }) {
      nodes {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
    sanityHome {
      dinarIntro {
        title {
          en
          ar
        }
        subTitle {
          en
          ar
        }
        description {
          en
          ar
        }
        steps {
          title {
            en
            ar
          }
          subTitle {
            en
            ar
          }
          icon {
            asset {
              url
              publicUrl
              gatsbyImageData(
                width: 1500
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
    sanityFundraiserRealEstate {
      hero {
        title {
          en
          ar
        }
        subTitle {
          en
          ar
        }
        limit {
          en
          ar
        }
        pointsIcon {
          asset {
            gatsbyImageData(
              width: 60
              placeholder: BLURRED
              formats: [AUTO, WEBP, AVIF]
            )
          }
        }
        points {
          en
          ar
        }
        rightButton {
          en
          ar
        }
        leftButton {
          en
          ar
        }
      }
      options {
        title {
          ar
          en
        }
        subTitle {
          ar
          en
        }
        options {
          title {
            ar
            en
          }
          subTitle {
            ar
            en
          }
          buttonTitle {
            ar
            en
          }
          link
          features {
            ar
            en
          }
          icon {
            asset {
              gatsbyImageData(
                width: 60
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
      benefits {
        title {
          ar
          en
        }
        subTitle {
          ar
          en
        }
        description {
          ar
          en
        }
        benefits {
          title {
            ar
            en
          }
          subTitle {
            ar
            en
          }
          icon {
            asset {
              gatsbyImageData(
                width: 60
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
      fundraiserForm {
        companyName {
          ar
          en
        }
        contactOptionsTitle {
          ar
          en
        }
        email {
          ar
          en
        }
        message {
          ar
          en
        }
        mobileNo {
          ar
          en
        }
        options {
          ar
          en
        }
        orgType {
          ar
          en
        }
        orgTypeOptions {
          ar
          en
        }
        title {
          ar
          en
        }
        subTitle {
          ar
          en
        }
        yearIncome {
          ar
          en
        }
        buttonTitle {
          ar
          en
        }
      }
      pageFaq {
        title {
          en
          ar
        }
        subTitle {
          en
          ar
        }
        questions {
          answers {
            en
            ar
          }
          title {
            en
            ar
          }
        }
      }
    }
  }
`;

export const Head = (props: any) => {
  const language = props?.params?.code === 'en' ? 'en' : 'ar';
  return (
    <SEO language={language} pathname={props?.location?.pathname} />
  )
}
